









































import { Component, Prop } from 'vue-property-decorator';
import { VehicleState } from '@/core/interfaces/vehicleState';
import VehicleStateIconItem from '@/components/vehicle-dashboard/vehicle-state/VehicleStateIconItem.vue';
import UsesTranslatableValue from '@/components/mixins/UsesTranslatableValue';
import { mixins } from 'vue-class-component';
import VehicleStateFactItem from '@/components/vehicle-dashboard/vehicle-state/VehicleStateFactItem.vue';

@Component({
    components: { VehicleStateFactItem, VehicleStateIconItem },
})
export default class DashboardVehicleState extends mixins(UsesTranslatableValue) {
  @Prop({ required: true })
  vehicleState!: VehicleState;
}

